import { render, staticRenderFns } from "./slotCom.vue?vue&type=template&id=cf170eb2&scoped=true"
import script from "./slotCom.vue?vue&type=script&lang=js"
export * from "./slotCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf170eb2",
  null
  
)

export default component.exports